import React from "react";
import PropTypes from "prop-types";
import "../../styles/HelperText.scss";
const HelperText = (props) => {
    const { text, isShownHelperIcon } = props;
    return (
        <React.Fragment>
            {isShownHelperIcon && <i className="far fa-question-circle helper-text-icon" />}
            {text && <span className="ml-3 helper-text">{text}</span>}
        </React.Fragment>
    )
};

HelperText.propTypes = {
    text: PropTypes.string,
    isShownHelperIcon: PropTypes.bool
}

export default HelperText;